import { Component } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'wm-libs-loading-spinner',
  templateUrl: './loading-spinner.component.html',
  styles: ['mat-spinner { margin: 0 auto; }'],
  standalone: true,
  imports: [MatProgressSpinnerModule],
})
export class AppLoadingSpinnerComponent {}
